import api from '@/services/api'
import useLoading from '@/composables/useLoading'
import useResponse from '@/composables/useResponse'
import { computed, ref, watch } from '@vue/composition-api'
import router from '@/router'

export default function useReception() {
  const list = ref([])
  const pagination = ref({
    page: 1,
    perPage: 2,
    totalPage: 1,
  })

  const { isLoading, startLoading, finishLoading } = useLoading()

  const tableColumns = [
    { key: 'id', label: '#' },
    { key: 'created_at', label: 'DATE' },
    { key: 'products', label: 'Products' },
    // { key: 'actions', label: 'Actions' },
  ]
  const paginationMeta = computed(() => ({
    from: pagination.value.perPage * (pagination.value.page - 1) + (list.value.length ? 1 : 0),
    to: pagination.value.perPage * (pagination.value.page - 1) + list.value.length,
    of: pagination.value.totalPage,
  }))

  // eslint-disable-next-line no-use-before-define
  watch(() => pagination.value.page, findAll)

  async function findAll() {
    try {
      startLoading()
      const response = useResponse(
        await api.reception.findAll({
          params: {
            order: router.currentRoute.params.id,
            limit: pagination.value.perPage,
            page: pagination.value.page,
          },
        }),
      )
      list.value = response.documents
      pagination.value.totalPage = response.pagination.totalPage
    } finally {
      finishLoading()
    }
  }

  function findOne({ id }) {
    return api.reception.findOne({ id })
  }

  function edit({ id, body }) {
    return api.reception.edit({ id, body })
  }

  function create({ body }) {
    return api.reception.create(body)
  }

  return {
    list,
    pagination,
    paginationMeta,
    tableColumns,
    isLoading,

    create,
    edit,
    findOne,
    findAll,
  }
}
